<script setup lang="ts">
import { defineProps, onBeforeMount, ref } from 'vue'
import { titleCaseWord } from '@/utils/textUtils'
import type { Partner } from '@/api-swagger'
import { usePartnerStore } from '@/stores/usePartnerStore'

const partnerStore = usePartnerStore()
interface Params {
  partner: Partner
}

const props = defineProps<{ params: Params }>()

const tableColors: Record<string, string> = {
  prospect: 'badge-primary',
  contact: 'badge-secondary',
  client: 'badge-accent',
  Active: 'badge-accent',
  NonActive: 'badge-warning',
}
const status = ref('')

const statusTextMap: Record<string, string> = {
  Active: 'Actif',
  NonActive: 'Inactif',
}

onBeforeMount(async () => {
  status.value = await partnerStore.getCurrentStatus(props.params.partner)
})
</script>

<template>
  <div :class="tableColors[status] + ' badge badge-md'">
    {{ statusTextMap[status] ?? titleCaseWord(status) }}
  </div>
</template>
